import { render, staticRenderFns } from "./HelpHeaderItem.vue?vue&type=template&id=7650c7e3"
import script from "./HelpHeaderItem.vue?vue&type=script&lang=js"
export * from "./HelpHeaderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports